export default "/images/35effd93c8859a8677bf30cc988b5ab0.avif";